import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Linkedin, Instagram, Twitter } from "lucide-react";
import { BRAND, NAV } from "@/lib/brand";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0F172A] text-slate-300 mt-12"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <img
                src={BRAND.logo}
                alt="RK Enterprises"
                className="h-12 w-12 object-contain bg-white rounded-sm p-1"
              />
              <div>
                <div className="font-display text-white font-extrabold text-lg">
                  RK Enterprises
                </div>
                <div className="text-[11px] text-[#67e8c4] font-semibold tracking-widest uppercase">
                  Manpower Services
                </div>
              </div>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              Reliable, skilled, and disciplined workforce solutions for
              factories, housekeeping, and industrial operations across India.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="#"
                aria-label="Facebook"
                data-testid="footer-social-facebook"
                className="h-9 w-9 grid place-items-center rounded-sm border border-slate-700 hover:border-[#1F6B5C] hover:text-white transition-colors"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a
                href="#"
                aria-label="LinkedIn"
                data-testid="footer-social-linkedin"
                className="h-9 w-9 grid place-items-center rounded-sm border border-slate-700 hover:border-[#1F6B5C] hover:text-white transition-colors"
              >
                <Linkedin className="h-4 w-4" />
              </a>
              <a
                href="#"
                aria-label="Instagram"
                data-testid="footer-social-instagram"
                className="h-9 w-9 grid place-items-center rounded-sm border border-slate-700 hover:border-[#1F6B5C] hover:text-white transition-colors"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                href="#"
                aria-label="Twitter"
                data-testid="footer-social-twitter"
                className="h-9 w-9 grid place-items-center rounded-sm border border-slate-700 hover:border-[#1F6B5C] hover:text-white transition-colors"
              >
                <Twitter className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display text-white font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              {NAV.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    data-testid={`footer-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="hover:text-white transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-white font-bold mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>Factory Workforce Supply</li>
              <li>Housekeeping Staff</li>
              <li>Shift-Based Labor</li>
              <li>Industrial Contract Staffing</li>
              <li>Skilled & Semi-Skilled Recruitment</li>
              <li>Long & Short-Term Staffing</li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-white font-bold mb-4">Get in touch</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex gap-3">
                <MapPin className="h-4 w-4 mt-0.5 text-[#67e8c4] shrink-0" />
                <span className="text-slate-400">
                  {BRAND.address.line1}
                  <br />
                  {BRAND.address.line2}
                </span>
              </li>
              {BRAND.phones.map((p) => (
                <li key={p} className="flex gap-3">
                  <Phone className="h-4 w-4 mt-0.5 text-[#67e8c4] shrink-0" />
                  <a
                    href={`tel:${p.replace(/\s/g, "")}`}
                    className="hover:text-white"
                    data-testid={`footer-phone-${p.replace(/[^0-9]/g, "")}`}
                  >
                    {p}
                  </a>
                </li>
              ))}
              {BRAND.emails.map((e) => (
                <li key={e} className="flex gap-3">
                  <Mail className="h-4 w-4 mt-0.5 text-[#67e8c4] shrink-0" />
                  <a
                    href={`mailto:${e}`}
                    className="hover:text-white break-all"
                    data-testid={`footer-email-${e.split("@")[0]}`}
                  >
                    {e}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p data-testid="footer-copyright">
            © {new Date().getFullYear()} RK Enterprises Manpower Services. All
            rights reserved.
          </p>
          <p>Proprietor: {BRAND.proprietor}</p>
        </div>
      </div>
    </footer>
  );
}
